import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FieldValues } from 'react-hook-form';
import localForage from 'localforage';

import { STEPS } from '../../../public/unregistered/unregistered-data';
import { queryClient } from '../../../../queryClient';
import { AssistanceInformation } from '../../../../models/assistance.model';
import { theme } from '../../../../global-styles/colors';
import { Heading2Text } from '../../../../components/typography/typography';
import AlxButton from '../../../../components/alx-components/button';
import { images } from '../../../../assets/images/images';
import { CallMeBackStyles } from './call-me-man-style';
import { ConfirmationStyle } from '../confirmation-style';

const CallMeBack = () => {
  const { t } = useTranslation(['common', 'aia']);
  const navigate = useNavigate();

  const assistanceData = queryClient.getQueryData<AssistanceInformation>(['assitanceInformation']);

  const onClose = async () => {
    const form: FieldValues | null = await localForage.getItem('assistanceFormNoLogin');
    if (form) {
      const step: number | null = await localForage.getItem<number>('unregisteredStep');
      if (step && step >= STEPS.STEP_IN_OUR_WAY && assistanceData?.identifier && assistanceData?.intervention) {
        navigate(`/unregistered/${assistanceData?.intervention}/${assistanceData?.identifier}`);
        return;
      }
      navigate('/');
    }
  };

  return (
    <ConfirmationStyle>
      <CallMeBackStyles>
        <Heading2Text className="m-24px" as="h1" weight={600} color={theme.neutrals.white}>
          {t('aia:confirmation.call-me-back.title')}
        </Heading2Text>
        <div className="confirmation-img">
          <img src={images.cars} alt="" />
        </div>
        <AlxButton
          className="secondary m-24px close-btn"
          onClick={() => {
            onClose();
          }}
        >
          {t('common:buttons.close')}
        </AlxButton>
      </CallMeBackStyles>
    </ConfirmationStyle>
  );
};

export default CallMeBack;
